import * as React from "react"
import PropTypes from "prop-types"
import "../../css/loader.css"

class Loader extends React.Component {
  render() {
    const { type, size, ...rest } = this.props
    return (
      <div className={`loader ${size} loader--${type}`} {...rest}>
        <span></span>
      </div>
    )
  }
}

Loader.defaultProps = {
  type: "color",
  size: "large",
}

Loader.protoType = {
  type: PropTypes.string,
  size: PropTypes.string,
}

export default Loader
